import React, { useState } from 'react';

import BasePrompt from 'components/base/prompt/BasePrompt';
import CustomerFilterableDropdown from 'components/transactions/CustomerFilterableDropdown';

import './TestAccountPrompt.scss';

function TestAccountPrompt({
  show = false,
  onHide = () => {},
  onConfirm = () => {},
}) {
  const [selectedAccount, setSelectedAccount] = useState();
  const [errorFields, setErrorFields] = useState([]);

  const handleOnConfirm = () => {
    if (!selectedAccount) {
      setErrorFields(['testAccount']);
    } else {
      onConfirm(selectedAccount);
    }
  };

  const otherBody = () => {
    return (
      <CustomerFilterableDropdown
        filterTestAccount={true}
        needLevelFilter={false}
        selectCustomer={(customer) => {
          setSelectedAccount(customer.value);
        }}
        errorName={'testAccount'}
        errorMessage="This field is required."
        errorFields={errorFields}
        title={'Account name'}
      />
    );
  };

  return (
    <BasePrompt
      show={show}
      closeAction={onHide}
      title={'Select Test Accounts'}
      description={
        "Select test accounts to send the message for testing purposes. To assign a customer as a test account, go to Customer > select a customer > Edit > select 'Assign as test customer’."
      }
      rightButton={{
        text: 'Send',
        action: handleOnConfirm,
      }}
      leftButton={{
        text: 'Cancel',
        action: onHide,
      }}
      otherBody={otherBody}
    />
  );
}

export default TestAccountPrompt;
